<template>

    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "LivePublishPolicy",
        components: {CommonTable},
        data(){
            return {
                searchs:[
                    {
                        name: 'policyId',
                        placeholder: '策略ID',
                        type: 'input'
                    },
                    {
                        name: 'userId',
                        placeholder: '用户ID',
                        type: 'input'
                    },
                    {
                        name: 'accountId',
                        placeholder: '账号ID',
                        type: 'input'
                    },
                    {
                        name: 'mode',
                        placeholder: '触发模式',
                        type: 'select',
                        selectValue: [{key:'once', value:'once'},{key:'schedule', value:'schedule'},{key:'loop', value:'loop'}]
                    },
                    {
                        name: 'enabled',
                        placeholder: '状态',
                        type: 'select',
                        selectValue: [{key:true, value:'启用'},{key:false, value:'禁用'}]
                    },
                    {
                        name: 'lastStatus',
                        placeholder: '最后状态',
                        type: 'input'
                    }
                ],
                permission:{
                    add: 'livePublishPolicy:add',
                    update: 'livePublishPolicy:update',
                    delete: 'livePublishPolicy:delete',
                    deleteBatch: 'livePublishPolicy:deleteBatch'
                },
                url: {
                    get: '/livePublish/policy/listByCondition',
                    add: '/livePublish/policy/add',
                    update: '/livePublish/policy/update',
                    delete: '/livePublish/policy/delete/',
                    delete_batch: '/livePublish/policy/deleteBatch'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '75',
                }, {
                    field: 'policyId',
                    label: '策略ID',
                    show: true,
                    width: '',
                }, {
                    field: 'userId',
                    label: '用户ID',
                    show: true,
                    width: '',
                }, {
                    field: 'accountId',
                    label: '账号ID',
                    show: true,
                    width: '',
                }, {
                    field: 'mode',
                    label: '触发模式',
                    show: true,
                    width: '100',
                }, {
                    field: 'enabled',
                    label: '状态',
                    show: true,
                    width: '80',
                }, {
                    field: 'startAt',
                    label: '开始时间',
                    show: true,
                    width: '',
                }, {
                    field: 'timezone',
                    label: '时区',
                    show: true,
                    width: '',
                }, {
                    field: 'runCount',
                    label: '运行次数',
                    show: true,
                    width: '100',
                }, {
                    field: 'nextRunAt',
                    label: '下次运行时间',
                    show: true,
                    width: '',
                }, {
                    field: 'lastRunAt',
                    label: '上次运行时间',
                    show: true,
                    width: '',
                }, {
                    field: 'lastStatus',
                    label: '最后状态',
                    show: true,
                    width: '100',
                }],
                operate: [
                    { name: 'edit', label: '编辑', type: 'text' },
                    { name: 'delete', label: '删除', type: 'text' }
                ],
                formFields: {
                    addTitle: '添加发布策略',
                    updateTitle: '修改发布策略',
                    model: [
                        { label: '策略ID', name: 'policyId', type: 'input', required: true, placeholder: '请输入策略ID' },
                        { label: '用户ID', name: 'userId', type: 'input', required: true, placeholder: '请输入用户ID' },
                        { label: '账号ID', name: 'accountId', type: 'input', required: true, placeholder: '请输入账号ID' },
                        { label: '触发模式', name: 'mode', type: 'select', required: true, placeholder: '请选择触发模式', selectValue: [{key:'once', value:'once'},{key:'schedule', value:'schedule'},{key:'loop', value:'loop'}] },
                        { label: '状态', name: 'enabled', type: 'switch', required: false, placeholder: '' },
                        { label: '开始时间', name: 'startAt', type: 'dateTime', required: false, placeholder: '请选择开始时间' },
                        { label: '时区', name: 'timezone', type: 'input', required: false, placeholder: '请输入时区' }
                    ]
                }
            }
        }
    }
</script>

<style scoped>

</style>
